import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import './admin/admin.css';
import BiryaniLanding from './BiryaniLanding';
import AdminRoutes from './admin/routes/AdminRoutes';
import { AuthProvider } from './admin/contexts/AuthContext';
import { ThemeProvider } from './admin/contexts/ThemeContext';
import CustomerApp from './customer/CustomerApp';
import KitchenApp from './kitchen/KitchenApp';
import BasicAuth from './components/BasicAuth';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Routes>
            <Route path="/" element={<BiryaniLanding />} />
            <Route path="/admin/*" element={<AdminRoutes />} />
            <Route path="/customer/*" element={
              <BasicAuth>
                <CustomerApp />
              </BasicAuth>
            } />
            {/* Kitchen portal — fully independent from customer auth */}
            <Route path="/kitchen/*" element={<KitchenApp />} />
          </Routes>
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover theme="colored" />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
